import styled from '@emotion/styled';
import { css } from '@emotion/react';

export type ColorType = 'white' | 'black';

interface ButtonProps {
  colorType?: ColorType;
}

export const Button = styled.a<ButtonProps>`
  font-size: 1.25rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.font.questrial};
  padding: 0.5rem 1.5625rem;
  position: relative;
  text-decoration: none;
  box-shadow: inset 0 0 0 0.0625rem ${({ theme }) => theme.colors.grey};
  background-color: ${({ theme }) => theme.colors.core_white};
  border-radius: 4rem;
  transition: background-color 200ms ease-in-out, box-shadow 200ms ease-in-out,
    color 200ms ease-in-out;
  margin-bottom: 0;
  width: 5rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;

  ${({ colorType, theme }) => {
    switch (colorType) {
      case 'white': {
        return css`
          background-color: ${theme.colors.core_white};
          svg {
            path {
              stroke: ${theme.colors.core_black};
            }
          }
        `;
      }
      case 'black': {
        return css`
          background-color: ${theme.colors.core_black};
          color: ${theme.colors.core_white};

          path {
            stroke: ${theme.colors.core_white};
          }
        `;
      }
    }
  }}

  &:before {
    content: '';
    z-index: -1;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 4rem;
    background: linear-gradient(
      88.48deg,
      #0f4ed7 0%,
      #684b9f 59.57%,
      #d2485c 98.61%
    );
  }

  &:hover {
    background-color: transparent;
    box-shadow: none;
    color: ${({ theme }) => theme.colors.core_white};

    path {
      stroke: ${({ theme }) => theme.colors.core_white};
    }
  }

  svg {
    path {
      transition: stroke 200ms ease-in-out;
    }
  }
`;
